import {DrawerFooter} from "@/widget/DrawerModal/DrawerModal";
import TextField from "@mui/material/TextField";
import {Controller, useForm} from "react-hook-form";
import {Autocomplete, FormLabel, Grid} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import React from "react"
import Box from "@mui/material/Box";
import {useAllDict} from "@/store/dict.c";
import {DictPO} from "@/model/system";
import {useDrawerModal, useGlobalActions} from "@/store/global.c";
import {SearchData} from "@/widget/SearchData/SearchData";
import CurrencyYuanOutlinedIcon from '@mui/icons-material/CurrencyYuanOutlined';
import {DatePickers} from "@/theme/DatePickers";
import DatePicker from "react-datepicker";
import * as z from "zod";
import {zodResolver} from "@hookform/resolvers/zod";
import {emptyValue, iso2Date} from "@/helper/method";
import {CustomerPO} from "@/model/customer";
import {SearchContractVO} from "@/service/contract.s";
import {RoleUserVO} from "@/service/user.s";
import {useRoleUsers} from "@/store/user.c";
import {useCreateProject, useQueryProject, useUpdateProject} from "@/service/project.s";
import {isNumber} from "lodash";

const validationSchema = z.object({
    id: z.number().default(0),
    customerId: z.number().default(0),
    customerName: z.string({message: "请选择关联客户"}).nonempty({message: "请选择关联客户"}),
    writer: z.unknown(),
    kind: z.unknown().default("项目申报"),
    kindId: z.unknown().default(1),
    writerId: z.number({message: "请填写撰稿人"}),
    subsidyAmount: z.unknown(),
    writeStatus: z.string({message: "请选择撰写状态"}).nonempty({message: "请选择撰写状态"}),
    writeStatusId: z.unknown(),
    category: z.string({message: "请选择政策项目名称"}).nonempty({message: "请选择政策项目名称"}),
    categoryId: z.unknown(),
    publicityDate: z.unknown().default(null),
    validDate: z.unknown().default(null),
    approvedYear: z.unknown().default(null),
    applyDate: z.unknown().default(null),
    explain: z.unknown(),
    contractId: z.unknown().default(0),
    contractName: z.unknown(),
    insideDeadline: z.unknown().default(null),
    price: z.unknown(),
    sellerId:
        z.number({message: "请选择业务人员"}),
    // assigner:
    //     z.unknown(),
    // assignerId:
    //     z.number({message: "请选择分配人"}),
    // tempAssigner:
    //     z.object({username: z.string().default(''), id: z.number()}).optional(),
    seller:
        z.unknown(),
    tempWriter:
        z.object({username: z.string().default(''), id: z.number()}).optional(),

    tempSeller:
        z.object({username: z.string().default(''), id: z.number()}).optional(),
    projectStatus:
        z.string({message: "请选择申报状态"}).nonempty({message: "请选择申报状态"}),
    projectStatusId:
        z.unknown(),
})

export type WriteProjectForm = z.infer<typeof validationSchema>

const defaultValues = emptyValue(validationSchema)

export const WriteProject = () => {
    const allDict = useAllDict()
    const seller = useRoleUsers(["marketing", "manager"])
    const declarer = useRoleUsers(["declarer", "financer"])
    const {projectType, projectStatus, writeStatus} = allDict
    const {setToast} = useGlobalActions()
    const {write, id: drawerId} = useDrawerModal()
    const {mutateAsync: createProjectMutate, isPending: createProjectPending} = useCreateProject()
    const {mutateAsync: updateProjectMutate, isPending: updateProjectPending} = useUpdateProject()
    const {data: projectData} = useQueryProject({id: drawerId!}, isNumber(drawerId))
    const project = projectData?.data
    const {onSearch} = useDrawerModal()
    const {setDrawerModal} = useGlobalActions()

    const initValues = () => {
        if (write == 'edit') {
            return {
                ...project, applyDate: iso2Date(project?.applyDate),
                writeStatusTime: iso2Date(project?.writeStatusTime), validDate: iso2Date(project?.validDate),
                publicityDate: iso2Date(project?.publicityDate), approvedYear: iso2Date(project?.approvedYear),
                tempWriter: {username: project?.writer, id: project?.writerId}, tempSeller: {username: project?.seller, id: project?.sellerId},
                tempAssigner: {username: project?.assigner, id: project?.assignerId}, contractName: project?.contract?.contractName,
                insideDeadline: iso2Date(project?.insideDeadline)
            };
        }
        return {kind: "项目申报", kindId: 1}
    }

    const {
        register,
        control,
        setValue,
        handleSubmit,
        reset,
        formState: {errors},
    } = useForm<WriteProjectForm>({
        values: initValues() as WriteProjectForm,
        resolver: zodResolver(validationSchema),
        defaultValues,
    });

    const onSubmit = async (values: WriteProjectForm) => {
        const result = write == 'add' ? await createProjectMutate(values) : await updateProjectMutate({...values, id: drawerId!})
        if (result.code == 0) {
            onSearch && onSearch()
            setDrawerModal({open: false})
            setToast({open: true, message: result.msg, severity: "success", variant: 'standard'})
        } else {
            setToast({open: true, message: result.msg, severity: "error", variant: 'standard'})
        }
    }

    return (
        <Box component={'form'} noValidate onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={3}>
                {/*<Grid size={6}>*/}
                {/*    <FormControl fullWidth={true} required={true}>*/}
                {/*        <FormLabel>服务类型</FormLabel>*/}
                {/*        <Controller control={control} render={({field: {onChange, value}}) => <Autocomplete*/}
                {/*            options={projectKind}*/}
                {/*            value={value as any}*/}
                {/*            onChange={(_, option: DictPO | null) => {*/}
                {/*                setValue("kindId", option?.value)*/}
                {/*                onChange(option?.label);*/}
                {/*            }}*/}
                {/*            fullWidth*/}
                {/*            renderInput={(params) => (*/}
                {/*                <TextField error={!!errors?.kind}*/}
                {/*                           helperText={errors?.kind?.message}*/}
                {/*                           variant="outlined"*/}
                {/*                           placeholder={"选择服务类型"} {...params} />*/}
                {/*            )}*/}
                {/*        />} name={"kind"}/>*/}
                {/*    </FormControl>*/}
                {/*</Grid>*/}
                <Grid size={6}>
                    <FormControl fullWidth={true} required={true}>
                        <FormLabel>政策项目名称</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <Autocomplete
                            options={projectType}
                            value={value as any}
                            onChange={(_, option: DictPO | null) => {
                                setValue("categoryId", option?.value)
                                onChange(option?.label);
                            }}
                            fullWidth
                            renderInput={(params) => (
                                <TextField error={!!errors?.category}
                                           helperText={errors?.category?.message}
                                           variant="outlined"
                                           placeholder={"选择政策项目名称"} {...params} />
                            )}
                        />} name={"category"}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true} required={true}>
                        <FormLabel>申报状态</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <Autocomplete
                            options={projectStatus}
                            value={value as any}
                            onChange={(_, option: DictPO | null) => {
                                setValue("projectStatusId", option?.value)
                                onChange(option?.label);
                            }}
                            fullWidth
                            renderInput={(params) => (
                                <TextField error={!!errors?.projectStatus}
                                           helperText={errors?.projectStatus?.message}
                                           variant="outlined"
                                           placeholder={"选择申报状态"} {...params} />
                            )}
                        />} name={"projectStatus"}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true}>
                        <FormLabel>提报日期</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <DatePickers>
                            <DatePicker
                                showYearDropdown={true}
                                showMonthDropdown={true}
                                dateFormat="yyyy/MM/dd"
                                selected={value as Date}
                                onChange={date => onChange(date)}
                                locale='zhCN'
                                placeholderText={"选择提报日期"}
                                customInput={<TextField
                                    sx={{
                                        width: "100%",
                                        "& .MuiInputBase-root": {padding: "8px 8px 8px 12px"},
                                    }}
                                />}
                            />
                        </DatePickers>} name={'applyDate'}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true}>
                        <FormLabel>公示日期</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <DatePickers>
                            <DatePicker
                                showYearDropdown={true}
                                showMonthDropdown={true}
                                dateFormat="yyyy/MM/dd"
                                selected={value as Date}
                                onChange={date => onChange(date)}
                                locale='zhCN'
                                placeholderText={"选择公示日期"}
                                customInput={<TextField
                                    sx={{
                                        width: "100%",
                                        "& .MuiInputBase-root": {padding: "8px 8px 8px 12px"},
                                    }}
                                />}
                            />
                        </DatePickers>} name={'publicityDate'}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true}>
                        <FormLabel>获批年度</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <DatePickers>
                            <DatePicker
                                showYearPicker={true}
                                showYearDropdown={false}
                                showMonthDropdown={false}
                                dateFormat="yyyy"
                                selected={value as Date}
                                onChange={date => onChange(date)}
                                locale='zhCN'
                                placeholderText={"选择获批年度"}
                                customInput={<TextField
                                    sx={{
                                        width: "100%",
                                        "& .MuiInputBase-root": {padding: "8px 8px 8px 12px"},
                                    }}
                                />}
                            />
                        </DatePickers>} name={'approvedYear'}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true}>
                        <FormLabel>补贴金额</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <TextField
                            type={'number'}
                            value={value}
                            onChange={event => onChange(parseInt(event.target.value || ""))}
                            slotProps={{
                                input: {
                                    inputProps: {
                                        min: 0,
                                        max: 1000000,
                                        maxLength: 8, inputMode: 'numeric', pattern: '[0-9]*'
                                    },
                                    endAdornment: <CurrencyYuanOutlinedIcon color="disabled"/>,
                                },
                            }}
                            placeholder="填写补贴金额"
                            variant="outlined"
                        />} name={'subsidyAmount'}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true}>
                        <FormLabel>资质有效期</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <DatePickers>
                            <DatePicker
                                showYearDropdown={true}
                                showMonthDropdown={true}
                                dateFormat="yyyy/MM/dd"
                                selected={value as Date}
                                onChange={date => onChange(date)}
                                locale='zhCN'
                                placeholderText={"选择资质有效期截止时间"}
                                customInput={<TextField
                                    sx={{
                                        width: "100%",
                                        "& .MuiInputBase-root": {padding: "8px 8px 8px 12px"},
                                    }}
                                />}
                            />
                        </DatePickers>} name={'validDate'}/>
                    </FormControl>
                </Grid>
                {/*<Grid size={6}>*/}
                {/*    <FormControl fullWidth={true} required={true}>*/}
                {/*        <FormLabel>分配人</FormLabel>*/}
                {/*        <Controller control={control} render={({field: {onChange, value}}) => {*/}
                {/*            return <Autocomplete*/}
                {/*                options={declarer}*/}
                {/*                value={value}*/}
                {/*                onChange={(_, option: RoleUserVO | null) => {*/}
                {/*                    setValue("assignerId", option!.id)*/}
                {/*                    setValue("assigner", option?.username)*/}
                {/*                    onChange(option)*/}
                {/*                }}*/}
                {/*                isOptionEqualToValue={(option, value) => option.id == value.id}*/}
                {/*                getOptionKey={option => option.username}*/}
                {/*                getOptionLabel={option => option.username}*/}
                {/*                fullWidth*/}
                {/*                renderInput={(params) => (*/}
                {/*                    <TextField error={!!errors?.assignerId}*/}
                {/*                               helperText={errors?.assignerId?.message}*/}
                {/*                               variant="outlined"*/}
                {/*                               placeholder={"选择分配人"} {...params} />*/}
                {/*                )}*/}
                {/*            />*/}
                {/*        }} name={"tempAssigner"}/>*/}
                {/*    </FormControl>*/}
                {/*</Grid>*/}
                <Grid size={6}>
                    <SearchData<WriteProjectForm, CustomerPO> control={control} attr={"customerName"} attrId={"customerId"} errMsg={errors.customerName?.message}
                                                              setValue={setValue}
                                                              label={"关联客户"}/>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true} required={true}>
                        <FormLabel>业务人员</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => {
                            return <Autocomplete
                                options={seller}
                                value={value}
                                onChange={(_, option: RoleUserVO | null) => {
                                    setValue("sellerId", option!.id)
                                    setValue("seller", option?.username)
                                    onChange(option)
                                }}
                                isOptionEqualToValue={(option, value) => option.id == value.id}
                                getOptionKey={option => option.username}
                                getOptionLabel={option => option.username}
                                fullWidth
                                renderInput={(params) => (
                                    <TextField error={!!errors?.sellerId}
                                               helperText={errors?.sellerId?.message}
                                               variant="outlined"
                                               placeholder={"选择业务人员"} {...params} />
                                )}
                            />
                        }} name={"tempSeller"}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <SearchData<WriteProjectForm, SearchContractVO> control={control} tag={2} attr={"contractName"} autoLoad={true} attrId={"contractId"} setValue={setValue}
                                                                    label={"关联合同"}/>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true}>
                        <FormLabel>价格</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <TextField
                            value={value}
                            onChange={event => onChange(event.target.value)}
                            slotProps={{
                                input: {
                                    inputProps: {
                                        min: 0,
                                        max: 1000000,
                                        maxLength: 8, inputMode: 'numeric', pattern: '[0-9]*'
                                    },
                                    endAdornment: <CurrencyYuanOutlinedIcon color="disabled"/>,
                                },
                            }}
                            placeholder="填写价格"
                            variant="outlined"
                        />} name={'price'}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true} required={true}>
                        <FormLabel>撰稿人</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => {
                            return <Autocomplete
                                options={declarer}
                                value={value}
                                onChange={(_, option: RoleUserVO | null) => {
                                    setValue("writerId", option!.id)
                                    setValue("writer", option?.username)
                                    onChange(option)
                                }}
                                isOptionEqualToValue={(option, value) => option.id == value.id}
                                getOptionKey={option => option.username}
                                getOptionLabel={option => option.username}
                                fullWidth
                                renderInput={(params) => (
                                    <TextField error={!!errors?.writerId}
                                               helperText={errors?.writerId?.message}
                                               variant="outlined"
                                               placeholder={"选择撰稿人"} {...params} />
                                )}
                            />
                        }} name={"tempWriter"}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true} required={true}>
                        <FormLabel>撰写状态</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <Autocomplete
                            options={writeStatus}
                            value={value as any}
                            onChange={(_, option: DictPO | null) => {
                                setValue("writeStatusId", option?.value)
                                onChange(option?.label);
                            }}
                            fullWidth
                            renderInput={(params) => (
                                <TextField error={!!errors?.writeStatus}
                                           helperText={errors?.writeStatus?.message}
                                           variant="outlined"
                                           placeholder={"选择撰写状态"} {...params} />
                            )}
                        />} name={"writeStatus"}/>
                    </FormControl>
                </Grid>
                <Grid size={6}>
                    <FormControl fullWidth={true}>
                        <FormLabel>内部期限</FormLabel>
                        <Controller control={control} render={({field: {onChange, value}}) => <DatePickers>
                            <DatePicker
                                showYearDropdown={true}
                                showMonthDropdown={true}
                                dateFormat="yyyy/MM/dd"
                                selected={value as Date}
                                onChange={date => onChange(date)}
                                locale='zhCN'
                                placeholderText={"选择内部期限"}
                                customInput={<TextField
                                    sx={{
                                        width: "100%",
                                        "& .MuiInputBase-root": {padding: "8px 8px 8px 12px"},
                                    }}
                                />}
                            />
                        </DatePickers>} name={'insideDeadline'}/>
                    </FormControl>
                </Grid>

                <Grid size={12}>
                    <FormControl fullWidth={true}>
                        <FormLabel>备注</FormLabel>
                        <TextField
                            multiline
                            rows={3}
                            {...register("explain")}
                            slotProps={{
                                input: {
                                    sx: {height: 'auto', minHeight: 80},
                                    inputProps: {
                                        maxLength: 250,
                                    },
                                },
                            }}
                            placeholder="输入备注"
                            fullWidth
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <DrawerFooter loading={createProjectPending || updateProjectPending} onReset={() => reset(defaultValues)}/>
        </Box>
    );
};
